import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

/**
 * Image component that abstracts the GatsbyImage implementation,
 * and fallbacks to a regular img if it's not supported (ie. SVGs).
 */
const ImageDisplay = ({ image, src, alt, ...props }) => {
	if (getImage(image))
		return <GatsbyImage image={getImage(image)} alt={alt} {...props} />;
	if (src) return <img src={src} alt={alt} {...props} />;

	return null;
};

ImageDisplay.propTypes = {
	image: PropTypes.object,
	src: PropTypes.string,
	alt: PropTypes.string,
};

ImageDisplay.defaultProps = {
	image: null,
	src: null,
	alt: '',
};

export default ImageDisplay;
